<div class="flex-row flex-justify-between" style="margin-bottom: 1rem;">
  @if (previewMode !== 'form') {
    <div class="flex-row flex-align-stretch">
      <p-input-group>
        <p-select
          [(ngModel)]="fieldService.AddField.new"
          [options]="fieldService.AddField.types"
          [style]="{width: '250px'}"
          scrollHeight="1000px"
          optionLabel="value"
          optionValue="name"
        />
        <p-button
          [label]="Yii.t('app', 'Add Field')"
          (click)="fieldService.AddNewField()"
        />
      </p-input-group>
    </div>
  } @else {
    <div>&nbsp;</div>
  }
  <div class="pull-right">
    <p-select-button
      [unselectable]="true"
      [(ngModel)]="previewMode"
      (onChange)="syncPreview()"
      [options]="previewOptions"
      optionLabel="label"
      optionValue="value"
    />
  </div>
</div>

<div>
  @if (previewMode == 'fields') {
    <div style="height: calc(100vh - 210px);width:100%;overflow: auto;padding: 1rem">
      <ng-fields-content></ng-fields-content>
    </div>
  }
  @if (previewMode == 'split') {
    <p-splitter [style]="{height: 'calc(100vh - 210px)'}" [minSizes]="[25,25]">
      <ng-template #panel>
        <div style="height: 100%;width:100%;overflow: auto;padding: 1rem">
        <ng-fields-content [previewMode]="previewMode"></ng-fields-content>
        </div>
      </ng-template>
      <ng-template #panel>
        <div style="height: 100%;width:100%;overflow: auto;padding: 2rem">
          <ng-forms-render
            style="width: 100%;max-width: 960px"
            [scenario]=""
            [canBeModified]="false"
            [builderMode]="true"
          />
        </div>
      </ng-template>
    </p-splitter>
  }
  @if (previewMode == 'form') {
    <div class="flex-row flex-justify-center" style="height: calc(100vh - 210px);width:100%;overflow: auto;padding: 1rem">
      <ng-forms-render
        style="width: 100%;max-width: 960px"
        [scenario]=""
        [canBeModified]="false"
        [builderMode]="true"
      />
    </div>
  }
</div>
